import Store from "./Store";
import RelationContact from "../../model/relation-contact.model";

export default class RelationContactStore extends Store<RelationContact> {
  protected override name: string = "relation-contacts";
}
